<template>
  <a class="lxm-item box" @click="clicked">
    <div class="level is-mobile">
      <div class="level-item has-text-left">
        <p class="lxm-item__name"><img v-if="showIcon" class="lxm-item__lock" src="../../images/main/lock.png">{{ name }}</p>
        <p class="lxm-item__sub">{{ update }}</p>
      </div>

      <div class="level-item has-text-centered">
        <p class="lxm-item__value">{{ value }}</p>
        <p class="lxm-item__sub">{{ valueSuffix }}</p>
      </div>
    </div>
  </a>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  a.lxm-item.box
    color: grey-darker
  .lxm-item
    &.box
      padding: spacing-small spacing
      &:not(:last-child)
        margin-bottom: spacing
  .lxm-item__name
    font-size: size
    text-overflow-ellipsis(siz(200))
  .lxm-item__value
    font-size: size-big
    color: brand-primary
  .lxm-item__sub
    font-size: size-small
    color: grey-dark
    margin-top: spacing-small
  .lxm-item__lock
    height: 16px
    margin-right: 4px
    margin-bottom: -2px
</style>

<script>
  import * as mTypes from '../../../store/mutation-types'
  export default {
    props: {
      name: String,
      value: [String, Number],
      update: String,
      valueSuffix: String,
      to: Object,
      showIcon: Number
    },
    methods: {
      clicked () {
        if (this.to) {
          this.$store.commit(mTypes.TRANSITION_SET_BACK)
          this.$router.push(this.to)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmItem.vue?13f57e95